export const EXCEL_ANALYSIS_TYPES = {
    BY_VALUE: {
        name: 'By value',
        value: 0,
    },
    BY_CORRECTNESS: {
        name: 'By correctness',
        value: 1,
    },
}
